// 公共模块
import http from './utils';
import { aigcPrefix, prefix, mockAigcPrefix, mockPrefix } from './constants';
import axios from 'axios';
import { PromptConfirmItemType } from '@op/components/GPT/types';
import { SAVE_PAGE_NAME } from '@op/components/GPT/constants';
import { notification } from 'tea-component';
import { asyncCreateShortUrl } from '@op/components/FilterCommon/utils/historyUtils';
import { getLinkDomain } from '@op/utils/url';

export const aigcSummarize: (
  payload: any,
  cancelCallback?: any,
) => Promise<any> | any = (payload, cancelCallback = () => {}) => {
  return http({
    url: `${aigcPrefix}/summarize`,
    method: 'post',
    data: payload,
    cancelToken: new axios.CancelToken(cancelCallback),
    headers: { 'Content-type': 'multipart/form-data' },
    timeout: 1000 * 60 * 60, // 暂时设定为30分钟
    errorHandler: true,
  }) as Promise<any>;
};

export const aigcUpload: (
  payload: any,
  cancelCallback?: any,
) => Promise<any> | any = (payload, cancelCallback = () => {}) => {
  return http({
    url: `${aigcPrefix}/upload`,
    method: 'post',
    data: payload,
    cancelToken: new axios.CancelToken(cancelCallback),
    headers: { 'Content-type': 'multipart/form-data' },
    timeout: 1000 * 60 * 60, // 暂时设定为30分钟
    errorHandler: true,
  }) as Promise<any>;
};

export const aigcAdvancedLimit: (
  cancelCallback?: any,
) => Promise<any> | any = () => {
  return http({
    url: `${prefix}/summary/advanced/limit`,
    method: 'post',
    errorHandler: true,
  }) as Promise<any>;
};

export const aigcCreateSummary: (
  payload: any,
  cancelCallback?: any,
) => Promise<any> | any = (payload, cancelCallback = () => {}) => {
  return http({
    url: `${prefix}/summary/advanced/create_summary`,
    method: 'post',
    data: payload,
    cancelToken: new axios.CancelToken(cancelCallback),
    errorHandler: true,
  }) as Promise<any>;
};

export const aigcCreateVideoSummary: (
  payload: any,
  cancelCallback?: any,
) => Promise<any> | any = (payload, cancelCallback = () => {}) => {
  return http({
    url: `${prefix}/summary/create_feeds_summary`,
    method: 'post',
    data: payload,
    cancelToken: new axios.CancelToken(cancelCallback),
    errorHandler: true,
  }) as Promise<any>;
};

export const aigcGetVideoSummary: (
  payload: any,
  cancelCallback?: any,
) => Promise<any> | any = (payload, cancelCallback = () => {}) => {
  return http({
    url: `${prefix}/summary/get_feeds_summary`,
    method: 'post',
    data: payload,
    cancelToken: new axios.CancelToken(cancelCallback),
    errorHandler: true,
  }) as Promise<any>;
};

export const aigcGetVideoExtInfo: (
  payload: any,
  cancelCallback?: any,
) => Promise<any> | any = (payload, cancelCallback = () => {}) => {
  return http({
    url: `${prefix}/video/ext_info`,
    method: 'post',
    data: payload,
    cancelToken: new axios.CancelToken(cancelCallback),
    errorHandler: true,
  }) as Promise<any>;
};

export async function aigcCreateTaskId({
  filter,
  promptInfo,
  cancelCallback,
  oriFilter,
  shortIdErrorMessage,
  savePrefix = '',
}: {
  oriFilter?: any;
  filter: any;
  promptInfo: PromptConfirmItemType;
  cancelCallback?: (cancelToken: any) => void;
  shortIdErrorMessage?: string;
  savePrefix?: string;
}): Promise<any | null> {
  let { shortId } = promptInfo;

  if (promptInfo.saveName) {
    if (!oriFilter?.[SAVE_PAGE_NAME]) {
      notification.error({
        description: '没有Page Name无法保存,请联系开发进行处理',
      });
    } else if (!shortId) {
      shortId = await asyncCreateShortUrl({
        filter: { ...oriFilter, ...filter, promptInfo },
        gameInfo: {
          edition_unified_id: filter.edition_unified_id,
          entity_type: filter.entity_type,
          id_type: filter.id_type,
        },
        updateUrl: false,
        errorText: shortIdErrorMessage,
        cancelFunc: cancelCallback,
      });

      if (!shortId) return null;
    }
  }

  const params = {
    ...filter,
    task_type: promptInfo.gptOptions,
    model_type: promptInfo.modelType,
    prompt: promptInfo.prompt,
  };

  // 判断是否要加场景
  if (promptInfo.scenario) {
    params.scenario = promptInfo.scenario;
  }

  // 判断是否要进行保存
  if (shortId) {
    params.should_save_report = true;
    params.short_url = shortId;
    params.save_report_name =
      (savePrefix ? `${savePrefix}-` : '') + promptInfo.saveName;
  }

  // 判断是否要发邮件
  if (promptInfo?.emailList && promptInfo?.emailList?.length > 0) {
    params.email = promptInfo.emailList.join(';');
  }
  if (promptInfo?.businessType) {
    params.business_type = promptInfo.businessType;
  }

  params.link_url_domain = getLinkDomain();

  return aigcCreateSummary(params, cancelCallback).then((data: any) => data);
}

export const aigcGetSummary: (
  payload: any,
  cancelCallback?: any,
) => Promise<any> | any = (payload, cancelCallback = () => {}) => {
  return http({
    url: `${prefix}/summary/advanced/get_summary`,
    method: 'post',
    data: payload,
    cancelToken: new axios.CancelToken(cancelCallback),
    errorHandler: true,
  }) as Promise<any>;
};

export const aigcDownloadAdvancedSummaryData: (
  payload: any,
  cancelCallback?: any,
) => Promise<any> | any = (payload, cancelCallback = () => {}) => {
  return http({
    url: `${prefix}/summary/advanced/download_summary`,
    method: 'post',
    data: payload,
    cancelToken: new axios.CancelToken(cancelCallback),
    errorHandler: true,
  }) as Promise<any>;
};

export const aigcSaveAiAnalysis: (
  payload: any,
  cancelCallback?: any,
) => Promise<any> | any = (payload, cancelCallback = () => {}) => {
  return http({
    url: `${prefix}/ai_analysis/save_summary`,
    method: 'post',
    data: payload,
    cancelToken: new axios.CancelToken(cancelCallback),
    errorHandler: true,
  }) as Promise<any>;
};
